import {
  ApplicationRef,
  Component, createComponent,
  ElementRef, EmbeddedViewRef, input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {IoReusableElement} from "@app/layout/components/io-reusable-components/element-models";
import {IoReusableUtils} from "@app/layout/components/io-reusable-components/io-reusable-utils";
import {SearchIconComponent} from "@app/layout/components/io-reusable-components/svg/search-icon/search-icon.component";

@Component({
  selector: 'app-reusable-header',
  imports: [],
  templateUrl: './reusable-header.component.html',
  styleUrl: './reusable-header.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ReusableHeaderComponent implements OnChanges {
  @ViewChild('headerRef') headerRef!: ElementRef<HTMLElement>;
  headerData = input<IoReusableElement>();
  constructor(private appRef: ApplicationRef) {}
  ngOnChanges(changes: SimpleChanges): void {
    var data = this.headerData();
    if (!!data) {
      IoReusableUtils.applyTokens(data);
      this.buildHeader(data);
    }
  }

  buildHeader(reusableFeed: IoReusableElement) {
    this.headerRef.nativeElement.replaceChildren();

    if (reusableFeed.alert_banner.enabled && reusableFeed.alert_banner.content) {
      const alert = IoReusableUtils.createElementFromReusableData('div', {className: 'io-alert'});
      alert.insertAdjacentHTML('afterbegin', reusableFeed.alert_banner.content);
      const close = IoReusableUtils.createElementFromReusableData('button', {textContent: '×', ariaLabel: 'Dismiss'});
      close.onclick = () => alert.remove();
      alert.append(close);
      this.headerRef.nativeElement.append(alert);
    }

    if (reusableFeed.menus.secondary.length) {
      const secondaryMenu = IoReusableUtils.buildMenu(reusableFeed.menus.secondary);
      const secondaryActions = IoReusableUtils.createElementFromReusableData('div', {className: 'io-actions'});
      if (reusableFeed.header.search.enabled) {
        // Button to show searchbar
        const showSearchButton = IoReusableUtils.createElementFromReusableData('a', {});
        const searchButtonSvg = createComponent(SearchIconComponent, {
          hostElement: showSearchButton,
          environmentInjector: this.appRef.injector,
        });
        this.appRef.attachView(searchButtonSvg.hostView);

        // Button to submit search
        const searchFormSubmit = IoReusableUtils.createElementFromReusableData('button', {
          type: 'submit',
          className: 'io-search-submit'
        });
        const searchFormSvg = createComponent(SearchIconComponent, {
          hostElement: searchFormSubmit,
          environmentInjector: this.appRef.injector,
        });
        this.appRef.attachView(searchFormSvg.hostView);

        // Search bar form
        const form = IoReusableUtils.createElementFromReusableData('form', {className: 'io-search search-form', action: reusableFeed.header.search.action, method: 'get', role: 'search'},
          IoReusableUtils.createElementFromReusableData('div', {className: 'search-form-container'}, [
            IoReusableUtils.createElementFromReusableData('input', {type: 'search', name: 's', placeholder: 'Search…', ariaLabel: 'Search'}),
            searchFormSubmit
          ],
        ));

        showSearchButton.onclick = () => form.classList.toggle('search-active');
        secondaryActions.append(showSearchButton);
        secondaryActions.append(form);
      }
      const secondaryNav = IoReusableUtils.createElementFromReusableData('nav', {className: 'io-secondary'}, [secondaryMenu, secondaryActions]);
      this.headerRef.nativeElement.append(IoReusableUtils.createElementFromReusableData('div', {className: 'io-secondary-bar'}, secondaryNav));
    }

    const logo = IoReusableUtils.createElementFromReusableData('a', {href: reusableFeed.branding.logo_header.link},
      IoReusableUtils.createElementFromReusableData('img', {src: reusableFeed.branding.logo_header.url, alt: reusableFeed.branding.logo_header.alt, className: 'io-header-logo'}),);

    const nav = IoReusableUtils.createElementFromReusableData('nav', {className: 'io-nav'}, IoReusableUtils.buildMenu(reusableFeed.menus.primary));

    const actions = IoReusableUtils.createElementFromReusableData('div', {className: 'io-actions'});

    if (reusableFeed.header.appointment_button.enabled) {
      actions.append(IoReusableUtils.createElementFromReusableData('a', {
        className: 'io-btn',
        href: reusableFeed.header.appointment_button.url,
        textContent: reusableFeed.header.appointment_button.text
      }));
    }

    this.headerRef.nativeElement.append(IoReusableUtils.createElementFromReusableData('div', {className: 'io-header'}, [logo, nav, actions]));
  }

  readonly status = document.getElementById('status');
}
